<template>
  <b-row class="mb-1">
    <b-col sm="12">
      <b-card :title="notification.title">
        <b-card-text>
          <i>Le {{ formatDate(notification.created_at, '-') }} par {{ notification.creator ? notification.creator.prenom+' '+notification.creator.nom : 'Système' }}</i>
        </b-card-text>
        <b-card-text v-html="notification.message"></b-card-text>

        <b-card-text v-if="!isEmpty(notification.commentaire)" v-html="notification.commentaire">
        </b-card-text>

        <b-card-text v-if="/Dossier/.test(notification.target_type)">Vous pouvez accèder directement à ce dossier en cliquant sur le lien si dessous.</b-card-text>
        <a target="_BLANK" v-if="/Dossier/.test(notification.target_type)" :href="getUrlTarget(notification)" class="card-link">{{ notification.target_id }}</a>

        <b-card-text v-if="/Mail/.test(notification.target_type)">Vous pouvez accèder directement à cet email en cliquant sur le lien si dessous.</b-card-text>

        <a target="_BLANK" v-if="/Mail/.test(notification.target_type)" :href="getUrlTarget(notification)" class="card-link">{{ notification.target_id }}</a>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { isEmpty as isEmptyHelper } from "@/utils/fileHelper";
import {formatDateTime} from "@/utils/communHelper";

export default {
  name: 'Notification-card',
  props: [
    'notification',
  ],
  data: () => {
    return {
    }
  },
  methods: {
    formatDate(date) {
      return formatDateTime(date, '-');
    },
    isEmpty(data) {
      return isEmptyHelper(data);
    },
    getUrlTarget(selectedNotification) {
      let url = '#';
      let routeData = {};
      switch (true) {
        case /Dossier/.test(selectedNotification.target_type) :
          let traitementId = 1; //si pas de type, de forte chance qu'on soit en traitement PFE
          // TODO : voir comment récupérer le traitement de manière dynamique sans plomber les perfs
          if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'ij' ) {
            traitementId = 2
          } else if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'inval' ) {
            traitementId = 12
          } else if (selectedNotification.target && selectedNotification.target.type && selectedNotification.target.type.groupe.toLowerCase() === 'dc' ) {
            traitementId = 13
          }
          routeData = this.$router.resolve({name: 'fiche dossier', params: { id: selectedNotification.target_id }, query: {traitementId: traitementId}});
          url = routeData.href;
          break;
        case /Mail/.test(selectedNotification.target_type) :
          routeData = this.$router.resolve({name: 'Réception des mails', params: { id: selectedNotification.target_id }});
          url = routeData.href;
          break;
      }

      return url;
    },
  }
}
</script>
